/* Roční předplatné jako dárek – sekce tb-gift-* a snippet tb-gift-cta.

   Čtyři části:
   1. Uzávěrka: odpočty a texty, které se po uzávěrce a po Vánocích samy
      vymění. Data a texty bere z #tb-gift-config v sekci objednávky.
      Proč ne Liquid: Shopify stránky kešuje, „zbývá 5 dní“ by viselo dál.
   2. Objednávka (<tb-gift-order>): volba varianty, ceny, dárek / pro sebe,
      kam poslat prosincový balíček a kontrola údajů obdarovaného. Ceny jsou
      hotové z Liquidu pro každou variantu, tady se jen přepisují texty.
   3. Spodní lišta (<tb-gift-sticky>): po úvodu se ukáže, u objednávky zmizí.
   4. Karusel videí (<tb-gift-carousel>): šipky posouvají o jedno video.

   Skript se na stránku vkládá z více sekcí, proto pojistka tbGiftLoaded. */

(() => {
  if (window.tbGiftLoaded) return;
  window.tbGiftLoaded = true;

  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const pad = (n) => String(n).padStart(2, '0');

  function readJson(node, fallback) {
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return fallback;
    }
  }

  /* ------------------------------------------------------------------
     1. Uzávěrka
     ------------------------------------------------------------------ */

  const config = readJson(document.getElementById('tb-gift-config'), null);
  const deadline = config ? Date.parse(config.deadline) : NaN;
  const xmas = config ? Date.parse(config.xmas) : NaN;

  /** 0 = před uzávěrkou, 1 = do Štědrého dne, 2 = po Vánocích, -1 = bez uzávěrky. */
  function phaseAt(now) {
    if (!Number.isFinite(deadline)) return -1;
    if (now <= deadline) return 0;
    if (Number.isFinite(xmas) && now <= xmas) return 1;
    return 2;
  }

  let lastPhase = null;

  function fill(root, ms) {
    const parts = {
      d: String(Math.floor(ms / 864e5)),
      h: pad(Math.floor(ms / 36e5) % 24),
      m: pad(Math.floor(ms / 6e4) % 60),
      s: pad(Math.floor(ms / 1e3) % 60),
    };
    Object.entries(parts).forEach(([key, value]) => {
      $$(`[data-cd="${key}"]`, root).forEach((box) => {
        if (box.textContent !== value) box.textContent = value;
      });
    });
  }

  function tick() {
    const now = Date.now();
    const phase = phaseAt(now);
    if (phase < 0) return;

    const target = phase === 0 ? deadline : xmas;
    const ms = phase === 2 ? 0 : Math.max(0, target - now);

    $$('[data-gift-cd]').forEach((node) => {
      node.hidden = phase === 2;
      fill(node, ms);
    });
    $$('[data-gift-cd-inline-text]').forEach((node) => {
      node.hidden = phase !== 0;
      fill(node, ms);
    });

    if (phase === lastPhase) return;
    lastPhase = phase;
    window.tbGiftPhase = phase;

    /* Před uzávěrkou zůstávají texty z editoru, potom je přepíšou
       texty z objednávky – jeden zdroj pro celou stránku. */
    if (phase > 0) {
      $$('[data-gift-dl-line]').forEach((node) => {
        const text = config.line && config.line[phase];
        if (text) node.textContent = text;
      });
    }
    $$('[data-gift-cd-label]').forEach((node) => {
      node.textContent = (config.cdLabel && config.cdLabel[phase]) || '';
    });
  }

  if (config) {
    tick();
    setInterval(tick, 1000);
  }

  /* ------------------------------------------------------------------
     2. Objednávka
     ------------------------------------------------------------------ */

  const OUTPUTS = ['price', 'priceFull', 'was', 'save', 'pct', 'coffee', 'gifts', 'coffeeTitle', 'note'];

  class TbGiftOrder extends HTMLElement {
    connectedCallback() {
      this.variants = readJson(this.querySelector('[data-gift-variants]'), []);
      this.form = this.querySelector('form');
      this.idInput = this.querySelector('[data-gift-variant-id]');
      this.groups = $$('[data-gift-option]', this);
      this.status = this.querySelector('[data-gift-status]');
      if (!this.form || !this.idInput) return;

      /* Popisky voleb z Liquidu (např. „V60 zdarma“) si pamatujeme –
         poslední volba je přepisuje podle varianty. */
      $$('[data-gift-opt-sub]', this).forEach((node) => {
        node.dataset.base = node.textContent;
      });

      this.onChange = this.onChange.bind(this);
      this.onInput = this.onInput.bind(this);
      this.guard = this.guard.bind(this);
      this.onPick = this.onPick.bind(this);

      this.form.addEventListener('change', this.onChange);
      this.form.addEventListener('input', this.onInput);
      /* Horizon zachytává klik i odeslání už na document ve fázi capture,
         takže kontrola údajů musí sedět ještě výš – na window. */
      window.addEventListener('click', this.guard, true);
      window.addEventListener('submit', this.guard, true);
      document.addEventListener('click', this.onPick);

      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('click', this.guard, true);
      window.removeEventListener('submit', this.guard, true);
      document.removeEventListener('click', this.onPick);
    }

    selected() {
      return this.groups.map((group) => {
        const radio = group.querySelector('[data-gift-opt]:checked');
        return radio ? radio.value : null;
      });
    }

    matching(prefix) {
      return this.variants.filter((v) => prefix.every((value, i) => v.options[i] === value));
    }

    radio(index, value) {
      return $$('[data-gift-opt]', this.groups[index]).find((r) => r.value === value);
    }

    /* Tlačítko velikosti v sekci „Jak to funguje“ – nastaví variantu,
       odkaz pak sám sjede k objednávce. */
    onPick(event) {
      const pick = event.target.closest && event.target.closest('[data-gift-pick]');
      if (!pick) return;
      const variant = this.variants.find((v) => String(v.id) === pick.dataset.giftPick);
      if (!variant) return;
      variant.options.forEach((value, i) => {
        const radio = this.groups[i] && this.radio(i, value);
        if (radio) radio.checked = true;
      });
      this.update();
    }

    onChange(event) {
      const radio = event.target.closest('[data-gift-opt]');
      if (radio) this.syncFrom(Number(radio.closest('[data-gift-option]').dataset.giftOption));
      this.update();
    }

    onInput(event) {
      const field = event.target;
      if (field.getAttribute('aria-invalid') === 'true' && field.value.trim()) field.removeAttribute('aria-invalid');
      if (this.status && !this.status.hidden && this.missing().length === 0) this.status.hidden = true;
    }

    /* Po změně přípravy se množství srovná na hodnotu, která u ní
       existuje (filtr má jen 250 g). */
    syncFrom(index) {
      const selection = this.selected();
      for (let i = index + 1; i < this.groups.length; i += 1) {
        const pool = this.matching(selection.slice(0, i));
        if (pool.some((v) => v.options[i] === selection[i])) continue;
        const pick = pool.find((v) => v.available) || pool[0];
        if (!pick) continue;
        const radio = this.radio(i, pick.options[i]);
        if (radio) radio.checked = true;
        selection[i] = pick.options[i];
      }
    }

    update() {
      const selection = this.selected();
      const last = this.groups.length - 1;

      /* Hodnoty, které u zvolené přípravy nejsou, zůstanou vidět, jen
         vypnuté s popiskem („jen espresso“) – je vidět, že existují. */
      this.groups.forEach((group, i) => {
        if (i === 0) return;
        const pool = this.matching(selection.slice(0, i));
        $$('[data-gift-opt]', group).forEach((radio) => {
          const hit = pool.find((v) => v.options[i] === radio.value);
          radio.disabled = !hit;
          const sub = radio.closest('.tb-goffer__opt').querySelector('[data-gift-opt-sub]');
          if (!sub) return;
          if (!hit) sub.textContent = this.dataset.unavailable || '';
          else sub.textContent = (i === last && hit.sub) || sub.dataset.base || '';
        });
      });

      const variant = this.variants.find((v) => v.options.every((value, i) => value === selection[i])) || null;
      if (variant) {
        this.idInput.value = variant.id;
        OUTPUTS.forEach((key) => {
          $$(`[data-gift-o="${key}"]`).forEach((node) => {
            node.textContent = variant[key];
            if (key === 'note') node.hidden = !variant.note;
          });
        });
        $$('[data-gift-if]').forEach((node) => {
          node.hidden = !variant[node.dataset.giftIf];
        });
      }
      const prep = String(selection[0] || '').toLowerCase();
      $$('[data-gift-only]').forEach((node) => {
        node.hidden = node.dataset.giftOnly !== prep;
      });

      const modeRadio = this.form.querySelector('[data-gift-mode]:checked');
      const destRadio = this.form.querySelector('[data-gift-dest]:checked');
      const gift = !modeRadio || modeRadio.dataset.giftMode !== 'self';
      const dest = destRadio ? destRadio.dataset.giftDest : 'them';
      this.toggle('gift', gift);
      this.toggle('self', !gift);
      this.toggle('them', gift && dest === 'them');
      this.toggle('me', gift && dest === 'me');

      const title = this.querySelector('[data-gift-title]');
      if (title) title.textContent = gift ? this.dataset.titleGift : this.dataset.titleSelf;

      const available = Boolean(variant && variant.available);
      const label = this.querySelector('[data-gift-cta]');
      if (label) {
        label.textContent = available
          /* cena drzi pohromade (pevne mezery), na telefonu se nelame */
          ? `${gift ? this.dataset.ctaGift : this.dataset.ctaSelf} · ${String(variant.priceFull).replace(/ /g, '\u00a0')}`
          : this.dataset.soldOut;
      }
      const button = this.form.querySelector('button[name="add"]');
      if (button) button.disabled = !available;

      if (this.status && !this.status.hidden && this.missing().length === 0) this.status.hidden = true;
    }

    /* Skrytá část formuláře je i vypnutá, takže se její pole neodešlou. */
    toggle(name, on) {
      $$(`[data-gift-when="${name}"]`, this).forEach((node) => {
        node.hidden = !on;
        if (node.tagName === 'FIELDSET') node.disabled = !on;
      });
    }

    missing() {
      return $$('input[required]', this.form).filter((field) => {
        if (field.matches(':disabled')) return false;
        const value = field.value.trim();
        if (!value) return true;
        return field.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      });
    }

    guard(event) {
      if (event.type === 'click') {
        const button = event.target.closest && event.target.closest('button[name="add"]');
        if (!button || !this.form.contains(button)) return;
      } else if (event.target !== this.form) {
        return;
      }

      const missing = this.missing();
      if (missing.length === 0) return;

      event.preventDefault();
      event.stopPropagation();

      const names = missing.map((field) => {
        field.setAttribute('aria-invalid', 'true');
        const label = this.form.querySelector(`label[for="${field.id}"]`);
        const text = (label ? label.textContent : field.placeholder || field.name).trim();
        /* Jen první písmeno – „Z-BOX“ uprostřed věty zůstane velkými. */
        return text.charAt(0).toLowerCase() + text.slice(1);
      });

      if (this.status) {
        const template = this.dataset.missing || '[pole]';
        this.status.textContent = template.replace('[pole]', names.join(', '));
        this.status.hidden = false;
      }
      missing[0].focus();
    }
  }

  if (!customElements.get('tb-gift-order')) customElements.define('tb-gift-order', TbGiftOrder);

  /* ------------------------------------------------------------------
     3. Spodní lišta
     ------------------------------------------------------------------ */

  class TbGiftSticky extends HTMLElement {
    connectedCallback() {
      this.hero = document.querySelector('.tb-ghero');
      this.offer = this.closest('.tb-goffer');
      this.offerInView = false;
      this.hidden = false;

      this.update = this.update.bind(this);
      if (this.offer && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            this.offerInView = entries.some((entry) => entry.isIntersecting);
            this.update();
          },
          { rootMargin: '0px 0px -30% 0px' }
        );
        this.observer.observe(this.offer);
      }
      window.addEventListener('scroll', this.update, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.update);
      if (this.observer) this.observer.disconnect();
    }

    update() {
      const edge = this.hero ? this.hero.getBoundingClientRect().bottom : 600 - window.scrollY;
      this.classList.toggle('is-on', edge < 200 && !this.offerInView);
    }
  }

  if (!customElements.get('tb-gift-sticky')) customElements.define('tb-gift-sticky', TbGiftSticky);

  /* ------------------------------------------------------------------
     4. Karusel videí
     ------------------------------------------------------------------ */

  class TbGiftCarousel extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-car-track]');
      if (!track) return;
      const step = () => {
        const item = track.firstElementChild;
        return item ? item.getBoundingClientRect().width + 14 : 300;
      };
      const prev = this.querySelector('[data-car-prev]');
      const next = this.querySelector('[data-car-next]');
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    }
  }

  if (!customElements.get('tb-gift-carousel')) customElements.define('tb-gift-carousel', TbGiftCarousel);
})();
